import { Component, inject } from '@angular/core';
import { ButtonComponent } from "../../../../shared/button/button.component";
import { BenefitsService } from '@services/benefits.service';
import { ButtonColors } from '@models/enums/components/Button/ButtonColor.enum';

@Component({
    selector: 'app-benefits-button',
    imports: [
        ButtonComponent
    ],
    host: { '[class.hidden]': '!benefits.showButton()' },
    templateUrl: './benefits-button.component.html',
    styleUrl: './benefits-button.component.css'
})
export class BenefitsButtonComponent {

  // SERVICES
  public readonly benefits:    BenefitsService = inject(BenefitsService);

  // BUTTON TYPE
  public readonly buttonColor: ButtonColors    = ButtonColors.Vip;

}
